export const SIDE_PANEL_WIDTH = 460;
export const SIDE_PANEL_DATA_PANEL_WIDTH = 359;
export const SIDE_PANEL_DATA_PANEL_COLLAPSED_WIDTH = 40;
export const SIDE_PANEL_EXPANDED_WIDTH = SIDE_PANEL_WIDTH + SIDE_PANEL_DATA_PANEL_WIDTH;
export const SIDE_PANEL_COLLAPSED_WIDTH = SIDE_PANEL_WIDTH + SIDE_PANEL_DATA_PANEL_COLLAPSED_WIDTH;
export const SIDE_PANEL_FULLSCREEN_WIDTH = '100%';
export const FLOW_HEADER_HEIGHT_FALLBACK = 105;
export const ACTION_CONFIG_HEADER_HEIGHT = 45;